/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-08-19 09:48:33
 */
import React, { useState, useEffect} from "react";
import { Progress, Table, message, Image } from 'antd';
import type { TableColumnsType } from 'antd';
import { setApplyCount } from '@/features/user/userSlice';
import { useParams, useNavigate } from "react-router-dom";
import DeleteModal from '../../personal-center/components/delete-modal';
import OrderCancel from '../components/order-cancel';
import { orderCountTotal } from '@/api/personal-center';
import { afterSalesDetail, deleteAfterSales } from '@/api/after-sales';
import { DataType, processType, historyType, reasonType } from '../type';
import './index.scss';
import { dispatch } from "@/redux/store";
import { getBuyWay } from '@/utils';

const OrderDetail: React.FC = () => {
  const param = useParams();
  const navigate = useNavigate();
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [cancelFlag, setCancelFlag] = useState(false); // 取消订单
  const [orderDeleteModal, setOrderDeleteModal] = useState(false);
  const [merchBillList, setMerchBillList] = useState<DataType[]>([]);
  const [timeList, setTimeList] = useState<any>([]); // 时间节点
  const [processNum, setProcessNum] = useState(0); // 进度
  const [isRefresh, setIsRefresh] = useState(false); // 更新列表
  const [processList, setProcessList] = useState<processType[]>([
    {
      name: '售后申请',
      status: -1,
    },
    {
      name: '售后处理',
      status: 0,
    },
    {
      name: '售后完成',
      status: 1,
    }
  ])
  const merchBillColumns: TableColumnsType<DataType> = [
    {
    title: '订单商品',
    dataIndex: 'productName',
    width: 460,
    render: (text: string, record: DataType) => (
      <div className="name-show name1"
        // title={text + ' ' + (record.models.find((ele: any) => ele?.type === 1))?.models}
        title={text + ' ' + (record.models.find((ele: any) => ele?.type === 1))?.models + ' ' + (record.models.find((ele: any) => ele?.feeType === '2') ? getBuyWay((record.models.find((ele: any) => ele?.type === 1))?.subscribe[0]?.unit) : '')}
        onClick={() => window.open(`/detail?productSn=${record.productSn}`)}>
        {record.pmsFiles&&<img src={record.pmsFiles[0]?.url} alt="" />}
        {text}<span>
        {
          record.models.length > 0 &&
          <>
          {(record.models.find((ele:any)=>ele?.type===1))?.models} {record.models.find((ele:any)=>ele?.feeType==='2')&&getBuyWay((record.models.find((ele:any)=>ele?.type===1))?.subscribe[0]?.unit)}
          </>
        }
        </span>
      </div>
    ),
  },
    {
      title: '单价',
      dataIndex: 'price',
      render:(text: string) => (
        <span>¥{Number(text).toFixed(2)}</span>
      )
    },
    {
      title: '购买数量',
      dataIndex: 'quantity',
    },
    {
      title: '售后数量',
      dataIndex: 'applyQuantity',
    },
  ];
  useEffect(() => {
    orderDetailFunc();
  },[param.id])
  useEffect(() => {
    if(isRefresh) {
      orderDetailFunc();
    }
  },[isRefresh])
  // 售后详情
  const orderDetailFunc = () => {
    afterSalesDetail(param.id??'').then((gRes:any) => {
      if(gRes.success) {
        const getObj = gRes.obj;
        if(!getObj) {
          navigate('/user/as/List');
          return
        }
        setOrderInfo(getObj);
        setMerchBillList(getObj.productList);
        let timeArr = [getObj.createTime,getObj.handleTime,getObj.finishTime];
        if(getObj.status === 2) {
          const getList =  [...processList.slice(0, -1), {
            name: '已取消',
            status: 2,
          }]
          timeArr = [...timeArr.slice(0,-1),getObj.cancelTime];
          setProcessList(getList);
        }
        timeArr.forEach((nData:string,index:number) => {
          if(nData) {
            setProcessNum(((index+1)*100)/timeArr.length);
            return
          }
        })
        setTimeList(timeArr);
      }
    })
  }

  // 取消售后
  const cancelOrderDialog = () => {
    setCancelFlag(true);
    setIsRefresh(false);
  }
  // 删除订单弹窗
  const serviceDeleteDialog = () => {
    setOrderDeleteModal(true);
  }
  // 删除订单
  const orderDeleteFunc = () => {
    if(param.id && param.id !== '') {
      deleteAfterSales(param.id).then((dRes:any) => {
        if(dRes.success) {
          message.success('删除成功！');
          setOrderDeleteModal(false);
          navigate('/user/as/List');
          cartCountFunc();
        }else {
          message.error(dRes.message);
        }
      }) 
    }
  }
  // 更新数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setApplyCount(oRes.obj?.apply??0));
      }
    })
  }
  return (
    <div className="service-detail-main">
      <div className="order-head">
        售后详情
        <span className="after-number">售后单号：{orderInfo.applyNo}</span>
        <div className="after-sales">
          {
            orderInfo.status === 0 &&
            <span className="light" onClick={()=>cancelOrderDialog()}>取消售后</span>
          }
          {
            orderInfo.status === 2 &&
            <span onClick={()=>serviceDeleteDialog()}>删除</span>
          }
        </div>
      </div>
      <div className="order-detail-content">
        <h1>售后信息</h1>
        <div className="pay-review-process">
          {
            processList.map((pData:processType,index:number) => (
              <span key={index} style={{width: 310}}>{pData.name}</span>
            ))
          }
        </div>
        <Progress 
          percent={processNum} 
          showInfo={false} 
          size={[930,6]}
        />
        <div className="pay-review-process">
          {
            timeList.map((pData:string,index:number) => (
              <div className="process-time" key={index} style={{width: 310}}><span>{pData}</span></div>
            ))
          }
        </div>
       
        {
          orderInfo.histories?.length > 0 &&
          <>
            <div className="line"></div>
            <h1>售后处理</h1>
          </>
        }
        {
          orderInfo.histories?.length > 0 &&
          <ul>
            {
              orderInfo.histories.map((aData:historyType,index:number) => (
                <li key={index}>
                  <i></i>
                  <span className="order-time">{aData.createTime}</span>
                  <div className="order-dynamics">
                    {aData.content}
                  </div>
                </li>
              ))
            } 
          </ul>
        }
        <div className="line"></div>
        <h1>售后申请信息</h1>
        <div className="after-info">
          <div className="after-reason">申请原因：
            <span>{orderInfo.reasonStr}</span>
          </div>
          <div className="after-reason">问题描述：
            <span title={orderInfo.description}>{orderInfo.description}</span>
          </div>
          {
            orderInfo.reasonFiles?.length > 0 &&
            <>
              <div className="after-reason">上传图片：</div>
              <div className="reason-img-show">
                {
                  orderInfo.reasonFiles?.map((oData:reasonType) => (
                    <Image src={oData.url} width={100} key={oData.id} />
                  ))
                }
              
              </div>
            </>
          }
        </div>
        <div className="line"></div>
        <h1>售后商品</h1>
        <Table<DataType> 
          columns={merchBillColumns} 
          dataSource={merchBillList} 
          pagination={false} 
        />
      </div>
      <OrderCancel 
        cancelFlag={cancelFlag} 
        setCancelFlag={setCancelFlag} 
        orderId={param.id??''} 
        setIsRefresh={setIsRefresh} 
        cancelType={1}
      />
      <DeleteModal
        showDeleteModal={orderDeleteModal}
        setShowDeleteModal={setOrderDeleteModal}
        handleDelete={orderDeleteFunc}
        title='删除提醒'
        content='删除后该售后申请将从列表中移除，请确认是否删除？'
        okText='是'
        cancelText='否'
      />
    </div>
  )
}

export default OrderDetail;